import React from 'react';

const HeroSection = () => {
  const [lightbox, setLightbox] = React.useState(null);

  return (
    <div style={{ color: '#111827' }}>
      {/* MOBILE RESPONSIVE CSS */}
      <style>{`
        /* Mobile responsiveness */
        @media (max-width: 768px) {
          .preview-section {
            padding: 24px 16px !important;
          }
          .preview-title {
            font-size: 20px !important;
          }
          .preview-text {
            font-size: 15px !important;
          }
          .platform-section {
            padding: 24px 16px !important;
          }
          .contact-section {
            padding: 20px 16px !important;
          }
        }
        
        @media (max-width: 480px) {
          .preview-section {
            padding: 20px 12px !important;
          }
          .preview-title {
            font-size: 18px !important;
          }
          .preview-text {
            font-size: 14px !important;
          }
        }
      `}</style>

      {/* Product Preview Section */}
      <div
        className="preview-section"
        style={{
          backgroundColor: '#ffffff',
          padding: '40px',
          borderRadius: '12px',
          border: '1px solid rgba(0,0,0,0.1)',
          marginBottom: '18px',
          textAlign: 'left',
          boxShadow: '0 6px 20px rgba(0,0,0,0.1)',
        }}
      >
        <h3
          className="preview-title"
          style={{
            fontSize: '22px',
            fontWeight: '700',
            marginBottom: '20px',
            color: '#000000'
          }}
        >
          Experience the Platform
        </h3>

        <p
          className="preview-text"
          style={{
            fontSize: '17px',
            color: '#000000',
            marginBottom: '36px',
            lineHeight: '1.7',
          }}
        >
          Explore realistic Java exam simulations, instant feedback, and detailed mistake
          reviews — all in an exam-style interface designed to help you master Java SE 8
          OCA certification with confidence.{' '}
          <span style={{ color: '#121212ff', fontWeight: 'bold' }}>
            Click on each image to see a bigger preview.
          </span>
        </p>

        {/* Image Scroll Container */}
        <div style={{ position: 'relative', overflow: 'hidden', marginTop: '30px' }}>
          <div
            id="imageScroll"
            style={{
              display: 'flex',
              gap: '20px',
              overflowX: 'auto',
              scrollBehavior: 'smooth',
              paddingBottom: '10px',
            }}
          >
            {[
              {
                src: 'https://java-cert-web-clustermicro.s3.us-east-1.amazonaws.com/dashboard.png',
                alt: 'Dashboard Overview',
              },
              {
                src: 'https://java-cert-web-clustermicro.s3.us-east-1.amazonaws.com/pic+2.png',
                alt: 'Exam Interface',
              },
              {
                src: 'https://java-cert-web-clustermicro.s3.us-east-1.amazonaws.com/reviewpic.png',
                alt: 'Mistake Review',
              },
              {
                src: 'https://java-cert-web-clustermicro.s3.us-east-1.amazonaws.com/account.png',
                alt: 'Account Management',
              },
              {
                src: 'https://java-cert-web-clustermicro.s3.us-east-1.amazonaws.com/history.png',
                alt: 'Exam History',
              },
            ].map((img, idx) => (
              <img
                key={idx}
                src={img.src}
                alt={img.alt}
                onClick={() => setLightbox(img.src)}
                style={{
                  flex: '0 0 auto',
                  width: '44%',
                  maxWidth: '300px',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,0,0,0.1)',
                  boxShadow: '0 6px 20px rgba(0,0,0,0.1)',
                  cursor: 'pointer',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'scale(1.02)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.2)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.1)';
                }}
              />
            ))}
          </div>

          {/* Scroll Buttons */}
          <button
            onClick={() => {
              document.getElementById('imageScroll').scrollBy({ left: -400, behavior: 'smooth' });
            }}
            style={{
              position: 'absolute',
              top: '50%',
              left: '10px',
              transform: 'translateY(-50%)',
              backgroundColor: 'rgba(255,255,255,0.9)',
              border: 'none',
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
              cursor: 'pointer',
              fontSize: '18px',
              fontWeight: 'bold',
              zIndex: 10
            }}
          >
            ‹
          </button>

          <button
            onClick={() => {
              document.getElementById('imageScroll').scrollBy({ left: 400, behavior: 'smooth' });
            }}
            style={{
              position: 'absolute',
              top: '50%',
              right: '10px',
              transform: 'translateY(-50%)',
              backgroundColor: 'rgba(255,255,255,0.9)',
              border: 'none',
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
              cursor: 'pointer',
              fontSize: '18px',
              fontWeight: 'bold',
              zIndex: 10
            }}
          >
            ›
          </button>
        </div>

        {/* Lightbox overlay */}
        {lightbox && (
          <div
            onClick={() => setLightbox(null)}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0,0,0,0.85)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000,
              cursor: 'zoom-out',
            }}
          >
            <img
              src={lightbox}
              alt="Enlarged preview"
              style={{
                maxWidth: '92%',
                maxHeight: '92%',
                borderRadius: '10px',
                boxShadow: '0 0 25px rgba(255,255,255,0.3)',
              }}
            />
          </div>
        )}
      </div>

      {/* Our Comprehensive Practice Platform */}
      <div
        className="platform-section"
        style={{
          backgroundColor: '#ffffff',
          padding: '32px',
          borderRadius: '12px',
          marginBottom: '18px',
          border: '1px solid rgba(0,0,0,0.1)',
          boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
        }}
      >
        <h3
          style={{
            fontSize: '22px',
            fontWeight: '700',
            marginBottom: '20px',
            color: '#000000',
          }}
        >
          Our Comprehensive Practice Platform
        </h3>

        <ul style={{
          fontSize: '15px',
          lineHeight: '1.8',
          color: '#374151',
          paddingLeft: '20px',
          margin: 0
        }}>
          <li>Full-length realistic exams</li>
          <li>1624 questions, Detailed explanations for every question</li>
          <li>Performance analytics showing exactly where to focus</li>
          <li>Unlimited attempts for 6 months to build confidence before the real test</li>
        </ul>

        <p style={{
          fontSize: '16px',
          marginTop: '24px',
          padding: '16px',
          backgroundColor: '#777777',
          color: '#FFFF00',
          borderRadius: '8px',
          fontWeight: '500',
          margin: '24px 0 0 0'
        }}>
          Ready to become Certified? Create your account and start practicing today!
        </p>
      </div>

      {/* Contact Us + Policy Links + Trademark */}
      <div
        className="contact-section"
        style={{
          backgroundColor: '#ffffff',
          padding: '24px',
          borderRadius: '12px',
          border: '1px solid rgba(0,0,0,0.1)',
          boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
          textAlign: 'center',
        }}
      >
        <p style={{
          fontSize: '15px',
          color: '#080808',
          margin: '0 0 16px 0'
        }}>
          Contact us at: <strong>ab.clustermicro@gmail.com</strong>
        </p>
        
        {/* Policy Links */}
        <div style={{
          display: 'flex',
          gap: '16px',
          justifyContent: 'center',
          flexWrap: 'wrap',
          margin: '16px 0',
          padding: '12px 0',
          borderTop: '1px solid #ae7d2e',
          borderBottom: '1px solid #ae7d2e'
        }}>
          <a 
            href="/terms.html" 
            style={{
              fontSize: '13px', 
              color: '#080808',
              textDecoration: 'none',
              fontWeight: '500'
            }}
            onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
            onMouseOut={(e) => e.target.style.textDecoration = 'none'}
          >
            Terms & Conditions
          </a>
          <span style={{color: '#090909'}}>•</span>
          <a 
            href="/privacy.html" 
            style={{
              fontSize: '13px', 
              color: '#0c0c0c',
              textDecoration: 'none',
              fontWeight: '500'
            }}
            onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
            onMouseOut={(e) => e.target.style.textDecoration = 'none'}
          >
            Privacy Policy
          </a>
          <span style={{color: '#0f0f0e'}}>•</span>
          <a 
            href="/shipping.html" 
            style={{
              fontSize: '13px', 
              color: '#090909',
              textDecoration: 'none',
              fontWeight: '500'
            }}
            onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
            onMouseOut={(e) => e.target.style.textDecoration = 'none'}
          >
            Shipping & Delivery
          </a>
          <span style={{color: '#0c0c0c'}}>•</span>
          <a 
            href="/refund.html" 
            style={{
              fontSize: '13px', 
              color: '#0c0c0c',
              textDecoration: 'none',
              fontWeight: '500'
            }}
            onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
            onMouseOut={(e) => e.target.style.textDecoration = 'none'}
          >
            Refund Policy
          </a>
          <span style={{color: '#0a0a0a'}}>•</span>
          <a 
            href="/contact.html" 
            style={{
              fontSize: '13px', 
              color: '#0c0c0c',
              textDecoration: 'none',
              fontWeight: '500'
            }}
            onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
            onMouseOut={(e) => e.target.style.textDecoration = 'none'}
          >
            Contact Us
          </a>
        </div>
        
        <p style={{
          fontSize: '11px',
          color: '#161515',
          margin: 0,
          lineHeight: '1.5'
        }}>
          Java® and Oracle Certified Associate (OCA)® are registered trademarks of Oracle Corporation. 
          This website is not affiliated with or endorsed by Oracle.
        </p>
      </div>
    </div>
  );
};

export default HeroSection;
